export default __webpack_public_path__ + "static/listWeek-d4f735e96c13757a9790c77048fb5010.png";